import React, { useState, useEffect } from "react";
import "../../components/AddState/AddState.css";
import axios from "axios";

const AddState = ({ tokenStorage, openAddProfile, setOpenAddProfile }) => {
  const [countryResponse, setCountryResponse] = useState([]);
  const [selectedValue, setSelectedValue] = useState(null);

  const baseAPI = process.env.REACT_APP_API_URL;

  function tokenStorageState() {
    const storedToken = JSON.parse(localStorage.getItem("token"));
    //console.log(storedToken);

    if (storedToken) {
      axios
        .get(
          `${baseAPI}adminget/GETCountry?countryID=0`,
          {
            headers: {
              Authorization: `Bearer ${storedToken}`,
            },
          }
        )
        .then((response) => {
          //console.log(response.data.data);
          setCountryResponse(response.data.data);
        })
        .catch((error) => {
          console.error("Error fetching user detail:", error);
        });
    }
  };

  useEffect(() => {

    tokenStorageState();
  }, []);

  const [formData, setFormData] = useState({

    id: 0,
    country_id: "",
    name: "",

  });

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData({
      ...formData,
      [name]: value,
    });
  };

  const handleSubmit = async (e) => {
    e.preventDefault();

    try {
      const storedToken = JSON.parse(localStorage.getItem("token"));
      const postData = {
        ...formData,
      };

      const response = await axios.post(
        `${baseAPI}adminpost/AddState`,
        postData, // Send updated postData as the request body
        {
          headers: {
            Authorization: `Bearer ${storedToken}`,
          },
        }
      );

      setFormData({

        // id: "",
        country_id: "",
        name: "",
      });

      tokenStorage();
      setOpenAddProfile(!openAddProfile);
      // Clear the selected country value
      setSelectedValue("");
    }
    catch (error) {
      // Handle errors (e.g., show an error message)
      console.error("Error posting data:", error);
    }
  };

  const handleSelectChange = (event) => {
    // Handle the select input change and update the selected value
    formData.country_id = event.target.value;

  };

  return (
    <div className="container-fluid">
      <br />

      <div className="stateDetail">
        <form className="state-form">
          <table style={{ width: "100%" }}>
            <tr className="space">
              <td colSpan={3}></td>
            </tr>
            <tr className="tableHeading">
              <td>Country Name*</td>
              <td>State Name*</td>
            </tr>

            <tr>
              <td>
                <select className="dropdown-state"
                  name="country_id"
                  onChange={handleSelectChange}>
                  <option className="dropdown-state" value="">Select your option</option>
                  {countryResponse.map((item) => (
                    <option value={item.id}>{item.name}</option>

                  ))}

                </select>
              </td>
              <td>
                <input
                  type="text"
                  name="name"
                  value={formData.name}
                  placeholder="Enter Please"
                  onChange={handleChange}

                />
              </td>

            </tr>
            <tr className="space">
              <td colSpan={3}></td>
            </tr>
          </table>
          <br />
          <hr />
          <div className="reset-addState-button">
            <button type="submit" onClick={handleSubmit}
              style={{ marginRight: "10px", backgroundColor: "#5B489D", color: "white" }}>
              Add State
            </button>
            <button style={{ backgroundColor: "#F15843", color: "white" }}>
              Reset
            </button>

          </div>
        </form>
      </div>
      <br />
    </div>
  );
};

export default AddState;
